import { STATIC_IMAGE_URL } from './axios';

export const PLACEHOLDER_IMAGE = '/Images/placeholder.svg';

export const isValidImageFilename = (s) => {
  if (!s || typeof s !== 'string') return false;
  const trimmed = s.trim();
  // Must be at least 5 chars and contain a dot (so "1" or "img" are rejected).
  if (trimmed.length < 5 || !trimmed.includes('.')) return false;
  // Must not be a bare integer (legacy numeric ID stored in old records).
  if (/^\d+$/.test(trimmed)) return false;
  return true;
};

export const getImageBaseHost = () => {
  if (typeof process !== 'undefined' && process.env.REACT_APP_IMAGE_HOST) {
    return String(process.env.REACT_APP_IMAGE_HOST).replace(/\/+$/, '');
  }
  return (STATIC_IMAGE_URL || 'https://reseller-bazzar-media-india.s3.ap-south-1.amazonaws.com/uploads').replace(/\/+$/, '');
};

export const getProductImageUrl = (image) => {
  if (!image) return '';
  if (Array.isArray(image)) {
    image = image.find((img) => img && typeof img === 'string') || image[0];
  }
  if (typeof image !== 'string') return '';
  const isValidUrl = /^https?:\/\//.test(image);
  if (isValidUrl) return image;
  if (!isValidImageFilename(image)) return '';
  return `${getImageBaseHost()}/product_images/${image.trim()}`;
};

export const getBusinessImageUrl = (image) => {
  if (!image) return '';
  if (Array.isArray(image)) {
    image = image.find((img) => img && typeof img === 'string') || image[0];
  }
  if (typeof image !== 'string') return '';
  const isValidUrl = /^https?:\/\//.test(image);
  if (isValidUrl) return image;
  if (!isValidImageFilename(image)) return '';
  return `${getImageBaseHost()}/business_images/${image.trim()}`;
};

export const getBusinessLogoImageUrl = (image) => {
  if (!image) return '';
  if (Array.isArray(image)) {
    image = image.find((img) => img && typeof img === 'string') || image[0];
  }
  if (typeof image !== 'string') return '';
  const isValidUrl = /^https?:\/\//.test(image);
  if (isValidUrl) return image;
  if (!isValidImageFilename(image)) return '';
  return `${getImageBaseHost()}/business_logo/${image.trim()}`;
};

export const getBlogContentImageUrl = (image) => {
  if (!image) return '';
  const isValidUrl = /^https?:\/\//.test(image);
  if (isValidUrl) return image;
  if (!isValidImageFilename(image)) return '';
  return `${getImageBaseHost()}/blogs_images/${image.trim()}`;
};

export const getBlogMainImageUrl = (image) => {
  if (!image) return '';
  const isValidUrl = /^https?:\/\//.test(image);
  if (isValidUrl) return image;
  if (!isValidImageFilename(image)) return '';
  return `${getImageBaseHost()}/blog_main_image/${image.trim()}`;
};

export const getNewsImageUrl = (image) => {
  if (!image) return '';
  const isValidUrl = /^https?:\/\//.test(image);
  if (isValidUrl) return image;
  if (!isValidImageFilename(image)) return '';
  return `${getImageBaseHost()}/news_images/${image.trim()}`;
};
